const Partner = () => import('@/pages/partner/Partner');
export default {
  path: '/partner',//'/partner/:codeid?/:usinfo'
  component: Partner,
  name: 'Partner', 
  props: route => ({
    ...route.params
  }), 
}